import { BookOpen } from "lucide-react";
import { useState } from "react";

import { ColocaAccordion, ColocaAccordionItem } from "@/shared/components/layout/ColocaAccordion";
import useTranslations from "@/shared/lang/useTranslations";

const STORAGE_KEY = "coloca.paymentTaxes.guideOpen";

function readOpen(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== "false";
  } catch {
    return true;
  }
}

function writeOpen(open: boolean): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(open));
  } catch {
    // Storage blocked: the guide simply opens again next time.
  }
}

const SECTIONS = [
  ["guide_base_title", "guide_base_body"],
  ["guide_bearer_title", "guide_bearer_body"],
  ["guide_scope_title", "guide_scope_body"],
  ["guide_own_title", "guide_own_body"],
  ["guide_changes_title", "guide_changes_body"],
  ["guide_untaxed_title", "guide_untaxed_body"],
] as const;

export function TaxesHowItWorksGuide() {
  const { t } = useTranslations("paymentTaxes");
  const [open, setOpen] = useState(readOpen);

  return (
    <ColocaAccordion>
      <ColocaAccordionItem
        title={t("guide_title")}
        icon={BookOpen}
        open={open}
        onOpenChange={(next) => {
          setOpen(next);
          writeOpen(next);
        }}
      >
        <dl className="grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
          {SECTIONS.map(([titleKey, bodyKey]) => (
            <div key={titleKey} className="space-y-1">
              <dt className="text-sm font-semibold">{t(titleKey)}</dt>
              <dd className="text-sm text-muted-foreground">{t(bodyKey)}</dd>
            </div>
          ))}
        </dl>
      </ColocaAccordionItem>
    </ColocaAccordion>
  );
}
